import * as React from "react";
const CustomDocSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={57}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4.668}
      y={4}
      fill="#fff"
      fillOpacity={0.03}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4.668}
      y={4}
      stroke="#fff"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#fff"
      d="M19.25 33.25h19.5a.75.75 0 1 0 0-1.5H38v-1.5a9.011 9.011 0 0 0-8.25-8.968V19.75h1.5a.75.75 0 1 0 0-1.5h-4.5a.75.75 0 1 0 0 1.5h1.5v1.532A9.011 9.011 0 0 0 20 30.25v1.5h-.75a.75.75 0 1 0 0 1.5Zm2.25-3a7.5 7.5 0 0 1 15 0v1.5h-15v-1.5Zm18 5.25a.75.75 0 0 1-.75.75h-19.5a.75.75 0 1 1 0-1.5h19.5a.75.75 0 0 1 .75.75Z"
    />
  </svg>
);
export default CustomDocSVG;
